<template>
<div class="navigation-bar">
    <div class="navigation-bar-container">
        <b-navbar :close-on-click="true" :active="true">
            <template slot="brand">
                <b-navbar-item href="/">
                    <img class="logo" alt="Vue logo" src="../assets/logo.png" />
                </b-navbar-item>
            </template>
            <template slot="start" v-if="usuario">
                <b-navbar-dropdown :label="grupo.mgp_nombre" left collapsible v-for="grupo in modulo_grupos" :key="grupo.mgp_id">
                    <b-navbar-item class="option" tag="router-link" v-for="modulo in grupo.modulos" :key="modulo.mod_id" :to="modulo.mod_url">{{ modulo.mod_nombre }}<i class="mdi-chevron-right"></i>
                    </b-navbar-item>
                </b-navbar-dropdown>
            </template>
            <template slot="end" v-if="usuario">
                <b-navbar-dropdown :label="usuario.usu_nombre" right collapsible>
                    <b-navbar-item class="option" tag="router-link" to="/user/change-password">Cambiar Contraseña <i class="mdi-chevron-right"></i> </b-navbar-item>
                    <b-navbar-item class="option" @click.prevent="logout()">Cerrar sesion <i class="mdi-chevron-right"></i> </b-navbar-item>
                </b-navbar-dropdown>
            </template>
        </b-navbar>
    </div>
</div>
</template>
<script>
import { UsuarioService } from "../services"
import StoreAdapter from "../store/StoreAdapter"
export default {
    name: "NavBar",
    data() {
        return {

        }
    },
    computed: {
        usuario() {
            return StoreAdapter.get(StoreAdapter.modules.UsuarioStore.getters.usuario)
        },
        modulo_grupos() {
            let modulo_grupo = StoreAdapter.get(StoreAdapter.modules.UsuarioStore.getters.usuario).modulo_grupos
            modulo_grupo.forEach(grupo => {
                grupo.modulos = grupo.modulos.filter(modulo => modulo.mod_url != null)
            })
            return modulo_grupo
        }
    },
    methods: {
        logout() {
            UsuarioService.logout()
        },
    },
    mounted() {
        StoreAdapter.dispatch(StoreAdapter.modules.UsuarioStore.actions.loadUsuario)
    }
}
</script>